import { r as o, c as s, h as a, H as r, g as l } from "./main-bb89b2f2.js";
import { g as n } from "./getHTMLElements-42e066e3-4491c4a7.js";
import "vue";
const c = "*,:after,:before{border-color:var(--color-neutral-steel-200);border-style:solid;border-width:0;box-sizing:border-box}a{color:inherit;text-decoration:inherit}audio,canvas,embed,iframe,img,object,svg,video{display:block;vertical-align:middle}button,input,optgroup,select,textarea{font-feature-settings:inherit;color:inherit;font-family:inherit;font-size:100%;font-variation-settings:inherit;font-weight:inherit;letter-spacing:inherit;line-height:inherit;margin:0;padding:0}blockquote,dd,dl,fieldset,figure,h1,h2,h3,h4,h5,h6,hr,p,pre{margin:0}fieldset,legend{padding:0}.box-border{box-sizing:border-box}.block{display:block}.flex{display:flex}.h-full{height:100%}.w-full{width:100%}.flex-col{flex-direction:column}.flex-wrap{flex-wrap:wrap}:host{display:block}.main-navigation{background-color:var(--mainNavigation-surface-default-mobile);box-sizing:border-box;display:flex;flex-direction:column;flex-wrap:wrap;height:100%;-webkit-user-select:none;-moz-user-select:none;user-select:none;width:100%}@media (min-width:992px){.main-navigation.corporate{background-color:var(--mainNavigation-surface-default);flex-direction:row}}@media (min-width:1280px){.main-navigation.portal{background-color:var(--mainNavigation-surface-default);flex-direction:row}}.static{position:static}", d = c, m = class {
  constructor(t) {
    o(this, t), this.lhHeaderComponentRegister = s(this, "lhHeaderComponentRegister", 7), this.latestSubId = null, this.listOfItems = [], this.lhContext = "corporate";
  }
  /**
   * Child components are registered
   * @param evt
   */
  registerMainNavigationItems(t) {
    t.stopImmediatePropagation(), this.listOfItems.push(t.target);
  }
  /**
   * If subid is set on main navigation item this event is emitted
   * @param evt
   */
  toggleMobileMenu(t) {
    if (this.listOfItems.map((e) => {
      e != t.target && (e.submenuActive = !1);
    }), t.detail.subId) {
      const e = t.target;
      e.submenuActive = !0, this.latestSubId = t.detail.subId;
    }
  }
  /**
   * all child components are deactivated
   */
  async deactivateItems() {
    this.listOfItems.map((t) => {
      t.submenuActive = !1;
    });
  }
  async setFocus() {
    const t = n(this.hostElement, "patternlib-main-navigation-item"), e = t.find((i) => i.subid === this.latestSubId);
    if (e)
      e.setFocus();
    else if (t.length > 0) {
      const [i] = t;
      setTimeout(() => i.setFocus());
    }
  }
  async setTabIndex(t) {
    n(this.hostElement, "patternlib-main-navigation-item").forEach((e) => e.setTabIndex(t));
  }
  /**
   * return a item with a specific subid
   */
  async getItemBySubid(t) {
    for (const e of this.listOfItems)
      if (e.subid === t)
        return e;
    return null;
  }
  connectedCallback() {
    var t, e;
    const i = document.documentElement;
    i != null && (this.lhContext = (e = (t = i.getAttribute("context")) !== null && t !== void 0 ? t : i.getAttribute("data-context")) !== null && e !== void 0 ? e : "corporate");
  }
  componentWillLoad() {
    this.lhHeaderComponentRegister.emit("main-navigation");
  }
  render() {
    const t = {
      "main-navigation": !0,
      [this.lhContext]: !0
    };
    return a(r, { key: "f8ea1606743ae11985892c4de86a768faab61f17" }, a("nav", { key: "538b71484e0ead2c3186b51243b9b73741807f19", "aria-label": "Main navigation", class: t }, a("slot", { key: "5dc6b859dd48ccd3e3b4af1b89e50dded20d683c" })));
  }
  get hostElement() {
    return l(this);
  }
};
m.style = d;
export {
  m as patternlib_main_navigation
};
